import { render, staticRenderFns } from "./WwsMotherIcardPrint.vue?vue&type=template&id=8c4ffdb6&scoped=true&"
import script from "./WwsMotherIcardPrint.vue?vue&type=script&lang=js&"
export * from "./WwsMotherIcardPrint.vue?vue&type=script&lang=js&"
import style0 from "./WwsMotherIcardPrint.vue?vue&type=style&index=0&id=8c4ffdb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c4ffdb6",
  null
  
)

export default component.exports